import Link from 'next/link';
export default function parseTextWithLinks(text: string) {
  const parts = text.split(/(https?:\/\/[^\s]+)/g);
  return parts.map((part, index) => {
    if (part.match(/^https?:\/\/[^\s]+$/)) {
      const url = new URL(part);
      return <Link href={url.href} target="_blank" rel="noopener noreferrer" className="underline" key={index}>
					{url.host}
				</Link>;
    }
    return <span key={index} className="select-none">
				{part}
			</span>;
  });
}